import { useEffect, useState } from 'react';
import useAppStore from '../state/useAppStore';
import type { AppThemeMode } from './muiTheme';

const getSystemMode = (): 'light' | 'dark' =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';

const useResolvedThemeMode = (): AppThemeMode => {
  const themeMode = useAppStore((s) => s.themeMode);
  const [systemMode, setSystemMode] = useState<'light' | 'dark'>(getSystemMode);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => setSystemMode(e.matches ? 'dark' : 'light');
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  if (themeMode === 'system') return systemMode;
  return themeMode;
};

export default useResolvedThemeMode;
